<template>
  <RF-Dialog
  :cpntStatus='statusGeral'
  :cpntLargura='"90%"'
  :cpntStatusImprimir='buttonImprimir.statusImprimir'

  :cpntOnFecharDialog='produtoEtiquetaFechar'>
    <template slot='titulo'>
      <RF-Button
        :cpntId='buttonImprimir.id'
        :cpntStatus='buttonImprimir.status' 
        :cpntTexto='buttonImprimir.texto' 
        :cpntClass='buttonImprimir.class'
        :cpntDisabled='buttonImprimir.disabled'
        :cpntMostrar='buttonImprimir.mostrar'

        @onClickButton='buttonImprimir.onClick'
      ></RF-Button>
    </template>

    <template slot="conteudo">
      <div>
        <div id="pro-etiq-impressao">
          <table :style="'width: 100%; border-spacing: 0px; border-collapse: separate;'">
            <tr v-for="(linha, indexL) in cpntEtiquetas" :key="'pro-etiq-lin-' + indexL">
              <td v-for="(coluna, indexC) in linha" style="padding: 0px; vertical-align: top;" :key="'pro-etiq-lin-' + indexL + '-col-' + indexC">
                <div :data-time="time" :style="produtoEtiquetaImpressaoGerarStyle('celula', indexL, indexC)" :ref="'pro-etiq-lin-' + indexL + '-col-' + indexC + '-ref'">
                  <table :data-time="time" :style="produtoEtiquetaImpressaoGerarStyle('celula-table', indexL, indexC)">
                    <tr>
                      <!-- APRESENTA A LOGO DA EMPRESA -->
                      <td v-if="cpntConfig.fields.indexOf('logo') !== -1 && Number(cpntConfig.cfg_tam_logo) > 0" :data-time="time" :style="produtoEtiquetaImpressaoGerarStyle('td-logo', indexL, indexC)">
                        <img :src="$store.state.logotipo" :data-time="time" :style="produtoEtiquetaImpressaoGerarStyle('logo', indexL, indexC)" :ref="'pro-etiq-lin-' + indexL + '-col-' + indexC + '-logo'"/>
                      </td>

                      <td style="text-align: center;">
                        <!-- APRESENTA O CAMPO NOME -->
                        <div v-if="cpntConfig.fields.indexOf('pro_nome') !== -1" v-html="coluna.nome"></div>

                        <!-- APRESENA O CAMPO ID DO PRODUTO -->
                        <div v-if="cpntConfig.fields.indexOf('pro_codigo') !== -1" v-html="coluna.id"></div>

                        <!-- ARESENTA O CAMPO QTDE INICIAL DO PRODUTO -->
                        <div v-if="cpntConfig.fields.indexOf('pro_qtde_ini') !== -1" v-html="coluna.qtde_ini"></div>

                        <!-- ARESENTA O CAMPO QTDE INICIAL DO PRODUTO -->
                        <div v-if="cpntConfig.fields.indexOf('pro_qtde_est') !== -1" v-html="coluna.qtde_est"></div>

                        <!-- APRESENTA O CODIGO DE BARRAS DO PRODUTO -->
                        <div v-if="cpntConfig.fields.indexOf('pro_codigo_barras') !== -1 && coluna.cod_barra !== ''" style="text-align: center;" :ref="'pro-etiq-lin-' + indexL + '-col-' + indexC + '-barra'">
                          <!-- GERAR A IMAGEM DO CODIGO DE BARRAS -->
                          <svg class="barcode" v-if="coluna.cod_barra !== ''" :data-time="time" :style="produtoEtiquetaImpressaoGerarStyle('barra', indexL, indexC)"
                            jsbarcode-format="CODE128"
                            :jsbarcode-value="coluna.cod_barra"
                            jsbarcode-margin="0"
                            jsbarcode-width="1"
                            jsbarcode-textmargin="0"
                            jsbarcode-textPosition="top"
                            :jsbarcode-height="Number(cpntConfig.cfg_tam_cod_barra) + (cpntConfig.cfg_tam_cod_barra * '0.80')"
                          ></svg>
                          <div v-else :style="'height: ' + (Number(cpntConfig.cfg_tam_cod_barra) + 40) + 'px;' + fonte"></div>

                          <!-- APRESENTA O NUMERO DO CODIGO DE BARRAS -->
                          <div :data-time="time" :style="produtoEtiquetaImpressaoGerarStyle('barra-numero', indexL, indexC)" v-html="coluna.cod_barra"></div>
                        </div>

                        <!-- APRESENTA O VALOR DO PRODUTO -->
                        <div v-if="cpntConfig.fields.indexOf('pro_valor') !== -1" :data-time="time" :style="produtoEtiquetaImpressaoGerarStyle('valor', indexL, indexC)" v-html="coluna.valor_ven"></div>
                      </td>
                    </tr>
                  </table>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </template>
  </RF-Dialog>
</template>

<style socped>
</style>

<style>
  #pro-etiq-impressao > table > tr > td > div > table > tr > td > div > svg.barcode > g > text {
    display: none !important;
  }
</style>

<script>
  export default {
    props: {
      cpntEtiquetas: {
        required: true
      },
      cpntConfig: {
        required: true
      },
      cpntFecharFormulario: {
        required: true
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        config: '',
        buttonImprimir: '',
        fonte: ' font-family: Calibri; font-style: normal;'
      }
    },
    mounted: function () {
      this.produtoEtiquetaIniciar()
    },
    methods: {
      produtoEtiquetaIniciar: function () {
        var self = this

        // SETA O STAUS DA TELA
        self.produtoEtiquetaSetarStatusGeral('')

        // SETA O BOTÃO DE IMPRESSÃO
        self.buttonImprimir = {
          id: 'etiq-bt-imprimir',
          status: '',
          texto: 'Imprimir',
          statusImprimir: false,
          class: [ 'btn', 'btn-default', 'btn-sm' ],
          onClick: function () {
            // SETA O STATUS DO BOTÃO IMPRIMIR
            self.buttonImprimir.statusImprimir = true

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            setTimeout(function () {
              // CHAMADA DO PLUGIN PARA IMPRIMIR CONTEUDO DA DIV
              $('#pro-etiq-impressao').printElement({ etiqueta: true })

              // SETA O STATUS DO BOTÃO IMPRIMIR
              self.buttonImprimir.statusImprimir = false

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }, 300)
          }
        }

        setTimeout(function() {
          // CRIA OS CODIGOS DE BARRAS NA TELA
          var JsBarcode = require('jsbarcode')
          JsBarcode(".barcode").init()

          // setTimeout(function() {
          //   console.log(self.$refs)
          //   for (var key in self.$refs['svg']) {
          //     console.warn(self.$refs['svg'][key].style.width)
          //     self.$refs['svg'][key].style.width = (self.config.cfg_tam_celula - 12) + 'px'
          //     self.$refs['svg'][key].style.height = Number(self.config.cfg_tam_cod_barra) - 10
          //   }
          // }, 500)
        }, 500)
        
        // CHAMA A FUNÇÃO PARA FORÇAR A ATUALIZAÇÃO DE ALGUNS CAMPOS A CADA 1 SEGUNDO
        self.produtoEtiquetaForcarAtualizao(self)
      },
      produtoEtiquetaFechar: function () {
        // CHAMA A FUNÇÃO PARA FECHAR A TELA
        if (this.cpntFecharFormulario !== null) {
          this.cpntFecharFormulario()
        }
      },
      produtoEtiquetaSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      produtoEtiquetaForcarAtualizao: function (self, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
  
          // CHAMA A FUNÇÃO NOVAMENTE PARA CALCUALR A CADA X SEGUNDOS
          setTimeout(function () { self.produtoEtiquetaForcarAtualizao(self, (tentativa + 1)) }, 500)
        }
      },
      produtoEtiquetaImpressaoGerarStyle: function (tipo, indexL, indexC) {
        // RETORNA O VALOR MONTADO
        var retorno = []

        // INICIA AS VARIAVEIS UTILIZADAS
        var chave = ''
        var elemento = ''
        var tamanhos1 = ''
        var tamanhos2 = ''

        // INICIA A CHAVE QUE SERÁ TRATADA
        chave = 'pro-etiq-lin-' + indexL + '-col-' + indexC + '-ref'

        // VERIFICA A AÇÃO QUE DEVE FAZER EM CADA CASO
        switch (tipo) {
          case 'celula':
            // SETA O TAMANHO DA CELULA
            retorno.push('width: ' + this.cpntConfig.cfg_tam_celula + 'px;')
            retorno.push('min-width: ' + this.cpntConfig.cfg_tam_celula + 'px;')
            retorno.push('max-width: ' + this.cpntConfig.cfg_tam_celula + 'px;')

            // VERIFICA SE DEVE APLICAR BORDA
            if (this.cpntConfig.cfg_borda_etiq === '1') {
              retorno.push('border: 1px dotted;')
            }

            // SETA A MARGEM EXTERNA DA CELULA
            retorno.push('margin: ' + this.cpntConfig.cfg_f_mar_top + 'px ' + this.cpntConfig.cfg_f_mar_right + 'px ' + this.cpntConfig.cfg_f_mar_button + 'px ' + this.cpntConfig.cfg_f_mar_left + 'px;')

            // SETA A MARGEM INTERNA DA CELULA
            retorno.push('padding: ' + this.cpntConfig.cfg_d_mar_top + 'px ' + this.cpntConfig.cfg_d_mar_right + 'px ' + this.cpntConfig.cfg_d_mar_button + 'px ' + this.cpntConfig.cfg_d_mar_left + 'px;')
            break

          case 'celula-table':
            // SETA OS VALORES INICIAS PARA O CAMPO
            retorno.push('border-spacing: 0px;')
            retorno.push('border-collapse: separate;')

            // SETA O TAMANHO DA CELULA
            retorno.push('width: 100%;')
            // retorno.push('width: ' + this.cpntConfig.cfg_tam_celula + 'px;')
            retorno.push('min-width: ' + this.cpntConfig.cfg_tam_celula + 'px;')
            retorno.push('max-width: ' + this.cpntConfig.cfg_tam_celula + 'px;')
            break

          case 'logo':
            retorno.push('position: relative;')

            // INICIA A CHAVE QUE SERÁ TRATADA
            chave = 'pro-etiq-lin-' + indexL + '-col-' + indexC + '-ref'

            // VERIFICA O TAMANHO QUE DEVE DEIXAR A LOGO
            switch (this.cpntConfig.cfg_rotacao_logo) {
              case '90':
              case '270':
                // VERIFICA SE O CAMPO EXISTE
                if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1) {
                  // PEGA O ELEMENTO SOLICITADO
                  elemento = this.$refs[chave][0]
    
                  // PEGA O TAMANHO DO ELEMENTO
                  tamanhos1 = elemento.getBoundingClientRect()
    
                  // ADICIONA SE TEM ROTAÇÃO
                  retorno.push('transform: rotate(-' + this.cpntConfig.cfg_rotacao_logo + 'deg);')
    
                  // ADICIONA O TAMANHO CALCULADO
                  retorno.push('width: ' + tamanhos1.height + 'px;')
                }
    
                // INICIA A CHAVE QUE SERÁ TRATADA
                chave = 'pro-etiq-lin-' + indexL + '-col-' + indexC + '-logo'
    
                // VERIFICA SE O CAMPO EXISTE
                if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1) {
                  // PEGA O ELEMENTO SOLICITADO
                  elemento = this.$refs[chave][0]
    
                  // PEGA O TAMANHO DO ELEMENTO
                  tamanhos2 = elemento.getBoundingClientRect()
    
                  // SETA O TANTO DE DEVE RETONAR PARA ALINHAR NO MEIO DA CELULA
                  retorno.push('left: -' + (tamanhos2.width / 2) + 'px;')
                }
                break

              default:
                // VERIFICA SE O CAMPO EXISTE
                if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1) {
                  // PEGA O ELEMENTO SOLICITADO
                  elemento = this.$refs[chave][0]
    
                  // PEGA O TAMANHO DO ELEMENTO
                  tamanhos1 = elemento.getBoundingClientRect()
    
                  // ADICIONA SE TEM ROTAÇÃO
                  retorno.push('transform: rotate(-' + this.cpntConfig.cfg_rotacao_logo + 'deg);')
    
                  // ADICIONA O TAMANHO CALCULADO
                  retorno.push('width: ' + (tamanhos1.width * 0.40) + 'px;')
                }
                break
            }

            break

          case 'td-logo':
            // INICIA A CHAVE QUE SERÁ TRATADA
            chave = 'pro-etiq-lin-' + indexL + '-col-' + indexC + '-logo'

            // VERIFICA SE O CAMPO EXISTE
            if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1) {
              // PEGA O ELEMENTO SOLICITADO
              elemento = this.$refs[chave][0]

              // PEGA O TAMANHO DO ELEMENTO
              tamanhos1 = elemento.getBoundingClientRect()

              // SETA O ALINHAMENTO NO MEIO DA CELULA
              retorno.push('text-align: center;')

              // VERIFICA O TAMANHO QUE DEVE DEIXAR A LOGO
              switch (this.cpntConfig.cfg_rotacao_logo) {
                case '90':
                case '270':
                  // SETA O TANTO DE DEVE RETONAR PARA ALINHAR NO MEIO DA CELULA
                  retorno.push('width: ' + (tamanhos1.width + 1) + 'px;')
                  retorno.push('min-width: ' + (tamanhos1.width + 1) + 'px;')
                  retorno.push('max-width: ' + (tamanhos1.width + 1) + 'px;')
                  break

                default:
                  break
              }
            }
            break

          case 'barra':
            // SETA O ALINHAMENTO NO MEIO DA CELULA
            retorno.push('text-align: center;')

            // INICIA A CHAVE QUE SERÁ TRATADA
            chave = 'pro-etiq-lin-' + indexL + '-col-' + indexC + '-barra'

            // VERIFICA SE O CAMPO EXISTE
            if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1) {
              // PEGA O ELEMENTO SOLICITADO
              elemento = this.$refs[chave][0]

              // PEGA O TAMANHO DO ELEMENTO
              tamanhos1 = elemento.getBoundingClientRect()

              // SETA O TAMANHO DO CODIGO DE BARRAS AJUSTADO
              retorno.push('width: ' + (tamanhos1.width - (Number(this.cpntConfig.cfg_d_mar_left) + Number(this.cpntConfig.cfg_d_mar_right) + 5)) + 'px;')
            }
            break

          case 'barra-numero':
            // SETA OS VALORES INICIAS PARA O CAMPO
            retorno.push('position: relative;')
            retorno.push('margin-top: -16px;')
            retorno.push('text-align: center;')
            retorno.push('z-index: 99999;')
            retorno.push('margin-bottom: 5px;')

            // SETA O TAMANHO DA LETRA DO CODIGO DE BARRAS
            retorno.push('font-size: ' + this.cpntConfig.cfg_tam_font_cod + 'px;')

            // SETA O ESPAÇO ENTRE AS LETRAS DO CODIGO DE BARRAS
            retorno.push('letter-spacing: ' + this.cpntConfig.cfg_tam_esp_letra + 'px;')
            break

          case 'valor':
            // SETA O TAMANHO DA LETRA
            retorno.push('font-size: ' + this.cpntConfig.cfg_tam_font_valor + 'px;')
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CONVERTE EM STRING SE O VALOR FOR ARRAY
        retorno = typeof retorno === 'string' ? retorno : retorno.join(' ')

        // OS DADOS DA FONTE AO VETOR
        retorno += this.fonte

        // console.log(tipo, retorno)

        // RETORNA O VALOR MONTADO
        return retorno
      }
    }
  }
</script>
